var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    [
      _c(
        "FormFieldsContainer",
        { attrs: { titulo: "Retirada de Equipo" } },
        [
          _c("v-flex", { attrs: { sm12: "", md12: "" } }, [
            _c("p", [_c("b", [_vm._v(_vm._s(_vm.envio_Equipo))])])
          ])
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }